import React from 'react';
import {t} from '@lingui/core/macro';
import {Control} from 'react-hook-form';

import HintQuestion from '../Hint/HintQuestion';
import CustomSelect from '../CustomSelect/CustomSelect';

interface IDelaySelectorProps {
    control: Control<any>,
    name: string,
    value?: string | number | null,
}

export const buildDelaySelectOptions = () => {
    const delaySelectOptions = [
        {
            value: 0,
            label: t`Без задержки`,
        },
    ];

    let minute = 1;
    let minuteStep = 1;
    let delayLabel = '';
    const unitMin = ` ${t`мин.`}`;
    const unitHour = ` ${t`час.`}`;
    const delayPrefix = t`Задержка `;

    while (minute <= 720) {
        if (minute >= 20 && minute < 60) {
            minuteStep = 5;
            delayLabel = delayPrefix + minute + unitMin;
        } else if (minute >= 60 && minute < 120) {
            minuteStep = 10;
            delayLabel = delayPrefix + '1' + unitHour + (minute > 60 ? ' ' + String(minute - 60) + unitMin : '');
        } else if (minute >= 120) {
            minuteStep = 30;
            if ((minute / 60) % 1 === 0) {
                delayLabel = delayPrefix + String(minute / 60) + unitHour;
            } else {
                delayLabel = delayPrefix + String((minute / 60) - 0.5) + unitHour + ' 30' + unitMin;
            }
        } else {
            delayLabel = delayPrefix + minute + unitMin;
        }

        delaySelectOptions.push({
            value: minute,
            label: delayLabel,
        });

        minute += minuteStep;
    }

    return delaySelectOptions;
};

const DelaySelector: React.FC<IDelaySelectorProps> = ({
    control,
    name,
    value,
}) => {
    // eslint-disable-next-line max-len
    const DELAY = t`Уведомления приходят только, если инцидент длится дольше заданного времени. В журнале фиксируются все инциденты.`;


    return <>
        <div>
            <div className="d-flex justify-content-end">
                <CustomSelect
                    defaultValue={Number(value)}
                    control={control}
                    name={name}
                    data={buildDelaySelectOptions()}
                />
                <div className="align-content-center">
                    <HintQuestion placement="top">{DELAY}</HintQuestion>
                </div>
            </div>
        </div>
    </>;
};

export default DelaySelector;